"use client";

import type useLifestyleFilters from "../../hooks/useLifestyleFilters";
import type { PrizeCategory } from "../../lifestyle-constants";
import DrawerRow from "./DrawerRow";
import { filterScreensFor, selectionCountFor, type FilterScreenDefinition } from "./filterScreens";

interface CategoryPanelProps {
  category: PrizeCategory;
  filters: ReturnType<typeof useLifestyleFilters>;
  onOpenFilter: (filter: FilterScreenDefinition) => void;
}

/**
 * The second level of the drawer: the filters available within one category,
 * each drilling into its own screen. Engine size, top speed and the rest only
 * show where they apply.
 */
export default function CategoryPanel({ category, filters, onOpenFilter }: CategoryPanelProps) {
  const screens = filterScreensFor(category, filters);

  return (
    <div className="flex flex-col flex-1 min-h-0 overflow-y-auto">
      {screens.map(screen => (
        <DrawerRow
          key={screen.key}
          label={screen.label}
          count={selectionCountFor(screen.key, filters)}
          onClick={() => onOpenFilter(screen)}
        />
      ))}
    </div>
  );
}
